export const FETCH_SUSPICIOUS_NOTIFICATIONS = 'FETCH_SUSPICIOUS_NOTIFICATIONS';
export const FETCH_MORE_SUSPICIOUS_NOTIFICATIONS = 'FETCH_MORE_SUSPICIOUS_NOTIFICATIONS';
export const SET_SUSPICIOUS_NOTIFICATION_ADDRESSED = 'SET_SUSPICIOUS_NOTIFICATION_ADDRESSED';
